import React from 'react';
import {
    withStyles,
    Typography,
} from '@material-ui/core';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import PropTypes from 'prop-types';

const GET_INDICATOR_TYPES = gql`
  {
    allIndicatorTypes {
      _id
      name
      description
    }
  }
`;

const styles = theme => ({
   root : {
     marginLeft : 8,
     marginTop  : 16,
   }, 
   label : {
     marginBottom : 6
   }
});

const animatedComponents = makeAnimated();

//Transformación de valores para la adaptación del Select
const assingItems = (data=[]) => {
  const items = [];
  if(data.length > 0){
    data.forEach(item => {
      const obj = {label : item.name, value : item._id};
      items.push(obj);
    });
  }
  return items;
};

/**
 * Componente para la selección de tipos de indicadores
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
const SelectTags = ({classes, selected, tags=[]}) => {

  //Adaptación de valores seleccionados para retornar el array solo con los IDs
  //de los tipos seleccionados
  function assing(items=[]){
    let data = []
    items && items.forEach(element => {
        data.push(element.value);
    });
    selected(data);
  }

  return (
    <Query
      query = {GET_INDICATOR_TYPES}
    >
        {({loading, error, data}) => {
          return(
            <div className={classes.root}>
              <Typography variant="caption" className={classes.label}>Tipo de indicador</Typography>
              <Select
                placeholder       = "Seleccionar"
                closeMenuOnSelect = {false}
                components        = {animatedComponents}
                options           = {assingItems(data.allIndicatorTypes)}
                isMulti
                onChange          = {(items) => assing(items)}
                defaultValue      = {assingItems(tags)}
              />
            </div>
          )
        }}
    </Query>
  );
}

SelectTags.propTypes = {
  classes  : PropTypes.object, 
  selected : PropTypes.func, 
  tags     : PropTypes.array,
}

export default withStyles(styles)(SelectTags);



// WEBPACK FOOTER //
// ./src/components/admin/indicators/selectTags.js